import React from "react";

function Testimonials() {
	return (
		<div className="min-h-screen p-8 bg-white">
			<h2 className="text-3xl font-bold text-center mb-8">Testimonials</h2>
			<p className="text-center text-gray-600">Content coming soon...</p>
		</div>
	);
}

export default Testimonials;
